import './BetbookPostInfoBar.less';
import './BetbookPostInfoBar.dark.less';

import React from 'react';
import clsx from 'clsx';
import i18n from '../../common/i18n';
import { formatMoneyAmount } from '../../common/util';
import { isNumber } from 'lodash';

export interface BetbookPostInfoBarProps {
    className?: string;
    comments?: number;
    course?: number;
    deposit: number;
    eventualWin?: number;
    inspirations: number;
    isTicket?: boolean;
    isWin?: boolean;
    seen?: number;
}

export default function BetbookPostInfoBar({
    className,
    comments,
    course = 0,
    deposit,
    eventualWin = 0,
    inspirations,
    isTicket = false,
    isWin = false,
    seen = 0
}: BetbookPostInfoBarProps) {
    const highlightInspirations = inspirations >= 100;
    return (
        <div className={clsx('betbook-post-info-bar', className)}>
            {inspirations !== undefined ? (
                <div
                    className={clsx(
                        'betbook-info-bar betbook-info-bar-border betbook-info-bar-inspiration-tile mr-10',
                        {
                            'betbook-info-bar-highlighted': highlightInspirations
                        }
                    )}
                >
                    <div className="betbook-info-bar-item">
                        <div className="betbook-info-bar-title">
                            <b data-atid="betbook-post-inspiration-count">{inspirations}</b>
                        </div>
                        <div className="c-black-50">{i18n('nui.betbook.inspiration-count')}</div>
                    </div>
                </div>
            ) : null}
            <div className={clsx('betbook-info-bar', { 'betbook-info-bar-border': !course })}>
                {deposit && (
                    <div className="betbook-info-bar-item">
                        <div className="betbook-info-bar-title">
                            <b data-atid="betbook-post-deposit-value">{formatMoneyAmount(deposit, '\u20ac', 2)}</b>
                        </div>
                        <div className="c-black-50">{i18n('common.deposit')}</div>
                    </div>
                )}
                {isTicket ? (
                    <>
                        <div className="betbook-info-bar-item betbook-info-bar-separator">
                            <div className="betbook-info-bar-title">
                                <b data-atid="betbook-ticket-course-count">{course}</b>
                            </div>
                            <div className="c-black-50">{i18n('nui.betbook.filters.range.odd')}</div>
                        </div>
                        <div className="betbook-info-bar-item betbook-info-bar-separator betbook-post-info-bar-mobile">
                            <div className={clsx({ 'won-deposit': isWin, 'betbook-info-bar-title': !isWin })}>
                                <b data-atid="betbook-ticket-eventual-win-count">
                                    {formatMoneyAmount(eventualWin, '\u20ac', 2)}
                                </b>
                            </div>
                            <div className="c-black-50">
                                {i18n(isWin ? 'nui.betbook.win' : 'nui.betbook.eventual.win.short')}
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="betbook-info-bar-item betbook-info-bar-separator">
                            <div className="betbook-info-bar-title" data-atid="betbook-analysis-seen-count">
                                {seen}
                            </div>
                            <div className="c-black-50">{i18n('common.count.seen')}</div>
                        </div>
                        {isNumber(comments) && (
                            <div className="betbook-info-bar-item betbook-info-bar-separator betbook-post-info-bar-mobile">
                                <div className="betbook-info-bar-title" data-atid="betbook-analysis-comments-count">
                                    {comments}
                                </div>
                                <div className="c-black-50">{i18n('betbook.info.bar.count.comments')}</div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
